import types from '../../types';

const robot = (
  state = {
    pnl: 0,
    pairs_settings: null,
    global_enabled: false,
    loading: true,
    volume_rates: null,
  },
  { type, payload },
) => {
  switch (type) {
    case types.GET_MARKET_MAKER_START:
      return { ...state, loading: true };

    // success
    case types.GET_MARKET_MAKER_SUCCESS:
      return { ...payload, loading: false };

    case types.GET_MARKET_VOLUME_RATES_SUCCESS:
      return { ...state, volume_rates: payload };
    // case types.PUT_MARKET_MAKER_SUCCESS:
    //   return { ...state, pairs_settings: payload.pairs_settings };
    case types.PUT_TOGGLE_ENABLED_SUCCESS:
      return { ...state, global_enabled: payload.enabled };
    case types.PUT_TOGGLE_VERSION_BOTS_ENABLED_SUCCESS:
      return {
        ...state,
        spot_enabled:
          payload.bot_version === 'spot' ? !!+payload.enabled : state.spot_enabled,
        spot_v2_enabled:
          payload.bot_version === 'spot_v2'
            ? !!+payload.enabled
            : state.spot_v2_enabled,
      };

    // failure
    case types.GET_MARKET_MAKER_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default robot;
